import { TrendingDown, TrendingUp } from 'lucide-react';
import { marked } from 'marked';
import React from 'react';
import { Card } from 'react-bootstrap';
import './MetricBlock.css';

interface MetricBlockProps {
  block: {
    title?: string;
    value?: string | number;
    description?: string;
    trend?: 'up' | 'down';
    label?: string;
  };
}

const MetricBlock: React.FC<MetricBlockProps> = ({ block }) => {
  const { title, value, description, trend, label } = block;

  const renderTrendIcon = (): React.ReactNode => {
    if (trend === 'up') {
      return <TrendingUp className="trend-icon trend-up" size={20} />;
    } else if (trend === 'down') {
      return <TrendingDown className="trend-icon trend-down" size={20} />;
    }
    return null;
  };

  return (
    <Card className="metric-block">
      <Card.Body>
        <div className="metric-header">
          <h6 className="metric-title text-muted mb-2">
            {title ? title : 'N/A'}
          </h6>
          {renderTrendIcon()}
        </div>
        <div className="metric-value-container">
          <h3 className="metric-value mb-2">{value ? value : ''}</h3>
          {label ? <span className="metric-label">{label}</span> : null}
        </div>
        {description ? (
          <div
            className="metric-description text-muted mb-0"
            dangerouslySetInnerHTML={{
              __html: String(marked.parse(description)),
            }}
          ></div>
        ) : (
          <div className="metric-description text-muted mb-0">
            No description available
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default MetricBlock;
